import React from 'react';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../components/Accordion';
import { useSEO } from '../hooks/useSEO';
export function GuideInvest() {
  useSEO('Ouvrir son Restaurant - ARWM | Guide Complet Marrakech', 'Guide complet pour ouvrir votre restaurant à Marrakech : démarches administratives, financement, ressources humaines, marketing et accompagnement ARWM.');
  const sections = [{
    id: 'etude-marche',
    title: 'Étude de Marché',
    content: "Contenu en développement. Cette section abordera l'analyse du marché de la restauration à Marrakech, l'identification de votre clientèle cible, et l'étude de la concurrence."
  }, {
    id: 'demarches-administratives',
    title: 'Démarches Administratives',
    content: 'Contenu en développement. Cette section détaillera toutes les démarches administratives nécessaires pour ouvrir un restaurant à Marrakech : licences, autorisations, inscriptions obligatoires.'
  }, {
    id: 'financement',
    title: 'Financement',
    content: 'Contenu en développement. Cette section présentera les différentes options de financement disponibles, les aides et subventions, ainsi que les conseils pour élaborer un business plan solide.'
  }, {
    id: 'ressources-humaines',
    title: 'Ressources Humaines',
    content: "Contenu en développement. Cette section couvrira le recrutement, la formation du personnel, la gestion des équipes, et les obligations légales en matière d'emploi."
  }, {
    id: 'marketing-communication',
    title: 'Marketing et Communication',
    content: 'Contenu en développement. Cette section proposera des stratégies de marketing digital, de communication locale, et de développement de votre présence en ligne.'
  }];
  return <div className="w-full" data-id="element-406">
      {/* Hero */}
      <section className="py-32 px-4 bg-arwm-maroon" data-id="element-407">
        <div className="max-w-[1280px] mx-auto text-center" data-id="element-408">
          <h1 className="font-cormorant text-7xl font-bold text-white mb-6" data-id="element-409">
            Ouvrir son Restaurant
          </h1>
          <p className="font-josefin text-xl text-arwm-cream max-w-3xl mx-auto" data-id="element-410">
            Guide complet pour créer et développer votre établissement à
            Marrakech
          </p>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-20 px-4 bg-white" data-id="element-411">
        <div className="max-w-[1280px] mx-auto" data-id="element-412">
          <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-413">
            <p className="font-josefin text-lg text-arwm-dark-text leading-relaxed" data-id="element-414">
              Vous envisagez d'ouvrir un restaurant à Marrakech ? L'ARWM vous
              accompagne dans votre projet avec ce guide pratique qui couvre
              toutes les étapes essentielles de la création de votre
              établissement.
            </p>
          </div>

          {/* Accordion Sections */}
          <div className="max-w-4xl mx-auto" data-id="element-415">
            <Accordion type="single" defaultValue="etude-marche" data-id="element-416">
              {sections.map((section, index) => <AccordionItem key={section.id} value={section.id} data-id="element-417">
                  <AccordionTrigger className="font-cormorant text-2xl font-bold text-arwm-dark-text hover:text-arwm-maroon" data-id="element-418">
                    {index + 1}. {section.title}
                  </AccordionTrigger>
                  <AccordionContent className="font-josefin text-arwm-dark-text pt-4 pb-6" data-id="element-419">
                    <div className="bg-arwm-light-gray p-8" data-id="element-420">
                      <p className="text-lg italic" data-id="element-421">{section.content}</p>
                      <p className="mt-4 text-sm" data-id="element-422">
                        Pour plus d'informations sur ce sujet, n'hésitez pas à{' '}
                        <a href="/contact" className="text-arwm-maroon font-semibold hover:underline" data-id="element-423">
                          nous contacter
                        </a>
                        .
                      </p>
                    </div>
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-4 bg-arwm-light-gray" data-id="element-424">
        <div className="max-w-[1280px] mx-auto text-center" data-id="element-425">
          <p className="font-josefin text-sm uppercase tracking-[4px] text-arwm-maroon mb-4" data-id="element-426">
            Accompagnement
          </p>
          <h2 className="font-cormorant text-5xl font-bold text-arwm-dark-text mb-6" data-id="element-427">
            Besoin d'Accompagnement ?
          </h2>
          <p className="font-josefin text-xl text-arwm-dark-text mb-10 max-w-2xl mx-auto" data-id="element-428">
            L'ARWM propose un accompagnement personnalisé pour les porteurs de
            projet. Contactez-nous pour en savoir plus.
          </p>
          <a href="/contact" className="inline-block px-6 py-4 bg-arwm-maroon text-arwm-cream font-josefin text-sm uppercase tracking-[3.2px] hover:bg-arwm-maroon-dark transition-colors" data-id="element-429">
            Nous Contacter
          </a>
        </div>
      </section>
    </div>;
}